/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DefinitionGet200Response,
  EventTimestamp,
  WatchdogDefinition,
  WatchdogEventList,
  WatchdogId,
} from '../models';
import {
    DefinitionGet200ResponseFromJSON,
    DefinitionGet200ResponseToJSON,
    EventTimestampFromJSON,
    EventTimestampToJSON,
    WatchdogDefinitionFromJSON,
    WatchdogDefinitionToJSON,
    WatchdogEventListFromJSON,
    WatchdogEventListToJSON,
    WatchdogIdFromJSON,
    WatchdogIdToJSON,
} from '../models';

export interface DefinitionGetRequest {
    useUid?: boolean;
}

export interface DefinitionIdDeleteRequest {
    id: number;
}

export interface DefinitionIdGetRequest {
    id: number;
}

export interface DefinitionIdPutRequest {
    id: number;
    json: WatchdogDefinition;
}

export interface DefinitionPostRequest {
    json: WatchdogDefinition;
}

export interface EventPostRequest {
    json: EventTimestamp;
}

/**
 * 
 */
export class WatchdogApi extends runtime.BaseAPI {

    /**
     * Return the definitions of all watchdogs.
     * Return all watchdog definitions.
     */
    async definitionGetRaw(requestParameters: DefinitionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DefinitionGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters.useUid !== undefined) {
            queryParameters['use_uid'] = requestParameters.useUid;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DefinitionGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Return the definitions of all watchdogs.
     * Return all watchdog definitions.
     */
    async definitionGet(requestParameters: DefinitionGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DefinitionGet200Response> {
        const response = await this.definitionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a watchdog definition.
     */
    async definitionIdDeleteRaw(requestParameters: DefinitionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchdogDefinition>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling definitionIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatchdogDefinitionFromJSON(jsonValue));
    }

    /**
     * Delete a watchdog definition.
     */
    async definitionIdDelete(requestParameters: DefinitionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchdogDefinition> {
        const response = await this.definitionIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the definition of the specified watchdog.
     * Return watchdog definition.
     */
    async definitionIdGetRaw(requestParameters: DefinitionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchdogDefinition>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling definitionIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatchdogDefinitionFromJSON(jsonValue));
    }

    /**
     * Return the definition of the specified watchdog.
     * Return watchdog definition.
     */
    async definitionIdGet(requestParameters: DefinitionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchdogDefinition> {
        const response = await this.definitionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a watchdog
     */
    async definitionIdPutRaw(requestParameters: DefinitionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchdogId>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling definitionIdPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling definitionIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WatchdogDefinitionToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatchdogIdFromJSON(jsonValue));
    }

    /**
     * Update a watchdog
     */
    async definitionIdPut(requestParameters: DefinitionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchdogId> {
        const response = await this.definitionIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Define a watchdog
     */
    async definitionPostRaw(requestParameters: DefinitionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchdogId>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling definitionPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WatchdogDefinitionToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatchdogIdFromJSON(jsonValue));
    }

    /**
     * Define a watchdog
     */
    async definitionPost(requestParameters: DefinitionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchdogId> {
        const response = await this.definitionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of the watchdog events triggered since the last call.
     * Get list of watchdog events
     */
    async eventGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchdogEventList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/event`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatchdogEventListFromJSON(jsonValue));
    }

    /**
     * Get a list of the watchdog events triggered since the last call.
     * Get list of watchdog events
     */
    async eventGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchdogEventList> {
        const response = await this.eventGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Reset the \'last call\' timestamp for the current user to the specified value.
     * Reset time of call
     */
    async eventPostRaw(requestParameters: EventPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventTimestamp>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling eventPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventTimestampToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventTimestampFromJSON(jsonValue));
    }

    /**
     * Reset the \'last call\' timestamp for the current user to the specified value.
     * Reset time of call
     */
    async eventPost(requestParameters: EventPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventTimestamp> {
        const response = await this.eventPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Wait until either a watchdog triggers, or a timeout occurs.
     * Wait for watchdog event
     */
    async waitGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchdogEventList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/wait`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WatchdogEventListFromJSON(jsonValue));
    }

    /**
     * Wait until either a watchdog triggers, or a timeout occurs.
     * Wait for watchdog event
     */
    async waitGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchdogEventList> {
        const response = await this.waitGetRaw(initOverrides);
        return await response.value();
    }

}
